import { Component, OnInit, Input, signal, viewChild, effect, untracked } from '@angular/core';
import { Parameters } from '@app/components/parameters/parameters';
import { ParametersService } from '@app/components/parameters/parameters.service';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { MachineInfosService } from '@app/components/machine-infos/machine-infos.service';
import { PoeModalService, TranslationService } from '@app/services';
import { IonIcon, IonSearchbar, IonSpinner } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { searchOutline } from 'ionicons/icons';
import { ProductSearchComponent } from '@app/components/product-search/product-search.component';
import { PlaygroundComponent } from '@app/components/playground/playground.component';
import { TileComponent } from '@app/components/tile/tile.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-machinesearch',
    templateUrl: './machinesearch.component.html',
    styleUrls: ['./machinesearch.component.scss'],
    imports: [
        RouterOutlet,
        PlaygroundComponent,
        ProductSearchComponent,
        TileComponent,
        IonIcon,
        IonSearchbar,
        IonSpinner,
        TranslateModule,
        CommonModule,
        FormsModule
    ]
})
export class MachinesearchComponent implements OnInit {
    @Input() machineAdd: boolean = false;
    @Input() embedded: boolean = false;
    params: Parameters = new Parameters();
    inpMachinennumber: string;
    loadsMachineData: boolean = false;
    readonly showChassisInput = signal(false);
    private readonly chassisSearchbar = viewChild<IonSearchbar>('chassisSearchbar');
    private readonly pendingChassisFocus = signal(false);

    constructor(
        public readonly router: Router,
        private readonly parametersService: ParametersService,
        private readonly machininfosService: MachineInfosService,
        private readonly modalService: PoeModalService,
        public readonly route: ActivatedRoute,
        private readonly translateService: TranslationService
    ) {
        addIcons({ searchOutline });

        effect(() => {
            const searchbar = this.chassisSearchbar();
            if (!searchbar || !this.pendingChassisFocus()) {
                return;
            }

            untracked(() => this.pendingChassisFocus.set(false));
            // Wait until Ionic has created the native input inside the searchbar.
            setTimeout(() => void searchbar.setFocus(), 50);
        });
    }

    ngOnInit() {
        this.parametersService.getParametersObservable()
            .subscribe(parameters => {
                this.params = parameters;
                if (this.params.country === undefined && this.params.user?.locale === undefined) {
                    this.router.navigate(['/locale']);
                }
            });

        this.params.fahrzeugNr = undefined;
    }

    onClickChassisCard(): void {
        this.showChassisInput.set(true);
        this.pendingChassisFocus.set(true);
    }

    onClickPfeil(): void {
        if (!this.inpMachinennumber || this.inpMachinennumber.length === 0) {
            return;
        }

        this.inpMachinennumber = this.inpMachinennumber.replace('VBP', '').replace(/^0+/, '');
        this.loadsMachineData = true;
        this.machininfosService.fetchMachineData(this.inpMachinennumber, 'de_AT', true)
            .subscribe({
                next: infos => {
                    if (infos.maktx) {
                        this.params.fahrzeugNr = this.inpMachinennumber;

                        if (this.params.fahrzeugNr && this.params.fahrzeugNr !== '') {
                            this.router.navigate(['/machine', this.params.fahrzeugNr]);
                        }
                    } else {
                        this.showInvalidMachineModal();
                    }
                    this.loadsMachineData = false;
                }, error: () => {
                    this.loadsMachineData = false;
                    this.showInvalidMachineModal();
                }
            });
    }

    private showInvalidMachineModal(): void {
        this.modalService.showInfoModal({
            title: this.translateService.translateInstant('Invalid Input'),
            message: this.translateService.translateInstant('Try a different value or select your machine out of our productrange'),
            confirmText: this.translateService.translateInstant('OK')
        });
    }
}
